export const ALERT_TYPES = {
  ADD_PRACTICE: 'addPractice',
}
